import React from 'react';

// INTERFACES
import { ISlideUp } from '../../interfaces/SlideUp.interface';

// STYLES
import { Indicator, SlideUpContainer } from './styles';

const SlideUp: React.FC<ISlideUp> = ({ black = false, children, isOpened, onClose, onOpen }: ISlideUp) => {
  return (
    <SlideUpContainer anchor="bottom" open={isOpened} onClose={onClose} onOpen={onOpen} black={black}>
      <>
        <Indicator />
        {children}
      </>
    </SlideUpContainer>
  );
};

export default SlideUp;
